import axios from 'axios';

//Dev
//const urlDev = "http://localhost/sendmail/send.php";
const urlDevMailchimp = "http://localhost/mailchimp/index.php";

//Prod
const website = 'https://libel.academy';
const urlProd = '/landing-curso-reto-cyberpunk/mailchimp/index.php';

//Service
const url= `${website}${urlProd}`;
const headers = { 'content-type': 'application/json'};

export const sendmail_service = (formData) => {
    return axios.post(urlProd, formData, { headers });
};

